module.exports = __webpack_public_path__ + "img/waving-hands.afaad43a.png";